export default __webpack_public_path__ + "static/media/Íconos 04.4f11ce3d.png";